import axios from "axios";
import dayjs from "dayjs";

export const getUsersClinicsStudoq = async ({
  perPage,
  currentPage,
  searchValue,
  clinicCode,
}: {
  perPage: number;
  currentPage: number;
  searchValue: string;
  clinicCode: string;
}) => {
  const url = new URL(
    `${process.env.REACT_APP_API_URL}/clinic/patients-studoq`
  );
  url.searchParams.append("clinicCode", clinicCode);
  url.searchParams.append("perPage", perPage.toString());
  url.searchParams.append("page", currentPage.toString());
  url.searchParams.append("search", searchValue);

  return axios
    .get(url.toString(), {
      withCredentials: true,
    })
    .then((response) => response.data);
};

export const sendEmailFirstPresentation = async (
  patientUserId: string,
  followupType: string,
  userId: string
) => {
  const url = new URL(`${process.env.REACT_APP_API_URL}/clinic/send-email`);

  return axios
    .post(
      url.toString(),
      {
        patientUserId,
        followupType,
        userId,
      },
      { withCredentials: true }
    )
    .then((response) => response.data);
};

export const updateOperationDate = async (
  newDate: dayjs.Dayjs,
  userId: string
) => {
  const url = new URL(
    `${process.env.REACT_APP_API_URL}/clinic/update-operation-date`
  );

  return axios
    .put(
      url.toString(),
      {
        newDate,
        userId,
      },
      { withCredentials: true }
    )
    .then((response) => response.data);
};
